import dom from "../../../dist/jsx-render/dom"
import { ColumnBase } from "./ColumnBase";
import { EditTypes } from "./EditTypes";

export class ColumnEditIcon extends ColumnBase {

    public getContent(row: any): HTMLElement {
        return <i className="fal fa-edit"></i>;
    }

    public createCell(rowModel: any, idField: string): HTMLElement {
        const cell = super.createCell(rowModel, idField);
        cell.classList.add("mt-edit-icon");
        cell.classList.add("pointer");
        cell.setAttribute("data-id", rowModel[idField]);
        cell.addEventListener("click", (ev: MouseEvent) => {
            ev.stopPropagation();
            if (this.table.props.onEditIconClicked) {
                this.table.props.onEditIconClicked(this.field, rowModel);
            }
            else if (this.def.editType != EditTypes.None) {
                this.table.showEditPopup(this.def.editType, rowModel);
            }
        });
        return cell;
    }
}